'use client'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons'
import { Button } from '@teqplay/ui'
import { useTranslations } from 'next-intl'

import { useRouter } from '@/i18n/navigation'
import useVesselTabState from '@/app/hooks/useVesselTabState'

type TPropsBackButton = {
  className?: string
  children?: React.ReactNode
  customURL?: string
}

function BackButton({ className, children, customURL }: TPropsBackButton) {
  const router = useRouter()
  const t = useTranslations('common')

  const { activeTab, portSlug } = useVesselTabState({ disableRedirectTab: true })

  return (
    <Button variant="brand-secondary" className={className} onClick={handleBack}>
      <>
        <FontAwesomeIcon icon={faArrowLeft} />
        {children || t('back')}
      </>
    </Button>
  )
  function handleBack() {
    if (activeTab === 'arrival') {
      router.push(`/${portSlug}/ships-expected`)
    } else if (activeTab === 'inPort') {
      router.push(`/${portSlug}/ships-at-port`)
    } else {
      router.push(customURL || '/')
    }
  }
}

export default BackButton
